module.exports = __webpack_public_path__ + "assets/img/44ff549ff659adae02e279b3448fd641.png";